'use strict';

import { slideToggle } from "../functions.js";

document.addEventListener('DOMContentLoaded', () => {
  const footerMenuTitle = document.querySelectorAll('.footer-menu__title');

  if(footerMenuTitle) {
    footerMenuTitle.forEach((item) => {
      item.addEventListener('click', (e) => {
        if(document.body.clientWidth < 768) {
          e.target.classList.toggle('footer-menu__title--open');
          slideToggle(e.target.nextElementSibling);
        }
      })
    });
  }

  if(footerMenuTitle) {
    window.addEventListener('resize', () => {
      footerMenuTitle.forEach((item) => {
        item.classList.remove('footer-menu__title--open');
        item.nextElementSibling.removeAttribute('style');
      });
    });
  }
});